module.exports = __webpack_public_path__ + "static/media/goals.bf69ffe0.png";